import { brandSecondary, titles } from '../../../web/styles/colors';
import { CssSelectors } from '../../../web/styles/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		boxSizing: 'border-box',
		color: titles,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 14,
		justifyContent: 'center',
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				marginBottom: 20,
			},
			':not(:last-child)'
		),
	},
	cta: {
		margin: '30px auto 0 auto',
	},
	icon: {},
	title: {
		color: brandSecondary,
		fontSize: 18,
		marginBottom: 15,
		textAlign: 'center',
	},
});
